export enum ProductSlug {
  Professional = 'Professional',
  Free = 'Free',
}

export enum ProductInterval {
  Year = 'year',
  Month = 'month',
}
